import React, { useState } from 'react';
import { useReducedMotion } from 'framer-motion';
type DeviceVideo = {
  src: string;
  poster?: string;
  label: string;
};
type DeviceVideoPairProps = {
  mobile: DeviceVideo;
  desktop: DeviceVideo;
  background: string;
  label: string;
};
type GrowStyle = React.CSSProperties & {
  '--grow': number;
};
const frame = 'overflow-hidden rounded-[10px] shadow-[0px_12px_40px_rgba(0,0,0,0.18)] min-[700px]:rounded-[20px]';

/** Width share for each video equals its aspect ratio, so both render at the same height side by side. */
const growClass = 'min-[700px]:w-auto min-[700px]:max-w-none min-[700px]:[flex:var(--grow)_1_0%]';
export function DeviceVideoPair({
  mobile,
  desktop,
  background,
  label
}: DeviceVideoPairProps) {
  const reduceMotion = useReducedMotion();
  const [mobileRatio, setMobileRatio] = useState(9 / 19.5);
  const [desktopRatio, setDesktopRatio] = useState(16 / 9);
  const videoProps = {
    autoPlay: !reduceMotion,
    muted: true,
    loop: true,
    playsInline: true,
    preload: 'metadata' as const,
    className: 'block h-auto w-full'
  };
  const readRatio = (set: (r: number) => void) => (e: React.SyntheticEvent<HTMLVideoElement>) => {
    const {
      videoWidth,
      videoHeight
    } = e.currentTarget;
    if (videoWidth && videoHeight) set(videoWidth / videoHeight);
  };
  return <section aria-label={label} className="w-full px-5 py-10 md:px-10 md:py-16" style={{
    background
  }} data-id="element-67" data-mp="25kyets3d9j7j">
      <div className="mx-auto flex max-w-[1100px] flex-col items-center gap-6 min-[700px]:flex-row min-[700px]:items-start min-[700px]:gap-8" data-id="element-68" data-mp="21hjwgurygqqx">
        <div className={`w-[60%] max-w-[260px] ${growClass} ${frame}`} style={{
        '--grow': mobileRatio
      } as GrowStyle} data-id="element-69" data-mp="1rkxdycn3qbs2">
          <video src={mobile.src} poster={mobile.poster} aria-label={mobile.label} onLoadedMetadata={readRatio(setMobileRatio)} {...videoProps} data-id="element-70" data-mp="1mo6vxjrql640" />
        </div>
        <div className={`w-full min-w-0 ${growClass} ${frame}`} style={{
        '--grow': desktopRatio
      } as GrowStyle} data-id="element-71" data-mp="1fb7rx1ilmvhp">
          <video src={desktop.src} poster={desktop.poster} aria-label={desktop.label} onLoadedMetadata={readRatio(setDesktopRatio)} {...videoProps} data-id="element-72" data-mp="1k2fzrt4a68sr" />
        </div>
      </div>
    </section>;
}